import { render, staticRenderFns } from "./UnitView.vue?vue&type=template&id=28e3f4fc"
import script from "./UnitView.vue?vue&type=script&lang=js"
export * from "./UnitView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports